import OfficeAddressForm from "./OfficeAddressForm";
import OfficeAddressListTable from "./OfficeAddressListTable";

export {
  OfficeAddressForm as SettingsOfficeForm,
  OfficeAddressListTable as SettingsOfficeListTable,
};
